import type { CSSProperties } from 'react';
import React from 'react';
import { Badge } from '@components/atoms/badge';
import { BadgeStatusEnum } from '@models/enums';
import { styled } from '@mui/material/styles';

export type BetaIconProps = {
    badgeStyle?: CSSProperties;
    className?: string;
};

const Icon: React.FC<BetaIconProps> = ({ badgeStyle = {}, className }) => (
    <Badge
        text='BETA'
        status={BadgeStatusEnum.PRIMARY}
        size='s'
        style={{
            ...badgeStyle,
        }}
        className={className}
    />
);

export const BetaIcon = styled(Icon)({});
